import {UIActionsList} from '../actions/UIActions';

export const initialState = {
    sent: false
}

const UIReducer = (state = initialState, action) => {

    switch (action.type) {

        case UIActionsList.SET_SENT:
            return setSent(state, action);
        default:
            return state;
    }

}

const setSent = (state) => {
    return {
        ...state,
        sent: true
    }
}

export default UIReducer;
